import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import { inject, observer } from 'mobx-react';

@inject('commonStore')
@observer
class PaymentError extends Component {
  constructor(props) {
    super(props);
    const { location, match, commonStore, t } = props;
    const params = queryString.parse(location.search);
    if (match.params.companyId) {
      commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);
    }

    if (params.errorCode) {
      switch (params.errorCode) {
        case '1':
          throw new Error(t('payment.error.expired'));
        // case '2':
        //   throw new Error(t('payment.error.amountMismatch'));
        case '3':
          throw new Error(t('order.error.discontinuedMenu'));
        case '4':
          throw new Error(t('order.error.soldOutMenu'));
        case '5':
          throw new Error(t('shop.error.closed'));
        case '6':
          throw new Error(t('payment.error.userCancel'));
        default:
          throw new Error(t('payment.error.failed'));
      }
    } else {
      throw new Error(t('payment.error.failed'));
    }
  }
}

export default withTranslation()(PaymentError);
